"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: "24px",
    width: "24px"
  }, props), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.27,11.72l-1.2-1.2a.36.36,0,0,0-.28-.12H12.92a4.79,4.79,0,1,0,0,3.2h.51l.68.68a.4.4,0,0,0,.57,0l.68-.68h.47l.68.68a.4.4,0,0,0,.57,0l.68-.68h1a.36.36,0,0,0,.28-.12l1.2-1.2A.39.39,0,0,0,20.27,11.72ZM6.81,13.2A1.2,1.2,0,1,1,8,12,1.2,1.2,0,0,1,6.81,13.2Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;